import axios from "@/app/Axios"

class Armafuego {
    /**GET */
    async index() {
        try {
            const response = await axios.get("/arma")
            //return response.data
            if (response && response.data) {
                return {
                    status: true,
                    records: response.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }

    async saveData(armaspost) {
        try {
            const response = await axios.post("/registroarmaindividualpost", armaspost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    /*     async registroarmasput(data) {
            try {
                const response = await axios.put("/registroarmaindividualput/${data.id_arma}", data)
                console.log("Esta es la respuesta:", response.data);
                return response.data
    
            } catch (error) {
                console.log(error);
            }
        } */
    async registroarmasput(data) {
        try {
            const response = await axios.put(`/registroarmaindividualput/${data.id_arma}`, data);
            // Comprobar si la respuesta tiene un estado exitoso (código de estado 2xx)
            if (response.status >= 200 && response.status < 300) {
                // Devolver los datos de la respuesta
                return response.data;
            } else {
                // Manejar una respuesta inesperada (fuera del rango de éxito)
                console.error(`Respuesta inesperada con código de estado ${response.status}`);
                // Puedes lanzar un error personalizado si lo deseas
                throw new Error(`Respuesta inesperada con código de estado ${response.status}`);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                // Manejar el error de autenticación (código 401)
                return error.response.data;
            } else {
                // Manejar otros errores
                console.error("Error en la solicitud PUT:", error);
                // Puedes lanzar un error personalizado o devolver un mensaje de error si lo deseas
                throw new Error("Error en la solicitud PUT. Consulta la consola para obtener más detalles.");
            }
        }
    }

    async deleteRegistroArmaIndividual(id) {
        try {
            const response = await axios.delete(`/registroarmaindividualdelete/${id}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async registroarmasget() {
        try {
            const response = await axios.get("/registroarmaindividual")
            //return response.data
            if (response && response.data) {
                return {
                    status: true,
                    records: response.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }
    async listadearmasfuego() {
        try {
            const startTime = performance.now();
            const response = await axios.get("/dotacionarmafuegoget")
            const endTime = performance.now();
            const elapsedTime = endTime - startTime;
            //return response.data
            if (response && response.data) {
                console.log("Estos son mis datos", response);
                console.log(`La solicitud tardó ${elapsedTime} milisegundos.`);
                return {
                    status: true,
                    records: response.data.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }
    async listadearmasfuego2() {
        try {
            const response = await axios.get("/dotacionarmafuegogetmodel")
            console.log("Esta es mi respuesta rapida", response.data);
            //return response.data
            if (response && response.data) {
                console.log("Estos son mis datos", response.data.data);
                return {
                    status: true,
                    records: response.data.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }

        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }
    async listadearmasfuegogeneral() {
        try {
            const startTime = performance.now();
            const response = await axios.get("/dotacionpistola/general")
            const endTime = performance.now();
            const elapsedTime = endTime - startTime;
            //return response.data
            if (response && response.data) {
                console.log("Estos son mis datos", response);
                console.log(`La solicitud tardó ${elapsedTime} milisegundos.`);
                return {
                    status: true,
                    records: response.data.data
                };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return {
                    status: false,
                    records: []
                };
            }
        } catch (error) {
            //console.log(error);
            if (error.response && error.response.status === 401) {
                return {
                    status: false,
                    message: error.response.data.message
                };
            } else {
                console.log(error);
                return {
                    status: false,
                    message: "Error interno del servidor"
                };
            }
        }
    }
}

export default Armafuego